<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">To Maxie, who has her own smaller budget (doggie day care, chew bones, lots and lots of food), but deserves an even bigger one!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?54d89509